/*eslint-disable*/
import React from 'react'
export const PlusIcon: React.FunctionComponent = () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 11 11"
        xmlSpace="preserve"
    >
        <path
            className="notrigger_st0"
            d="M5.5,0C2.5,0,0,2.5,0,5.5c0,3,2.5,5.5,5.5,5.5S11,8.5,11,5.5C11,2.5,8.5,0,5.5,0z M8,6H6v2H5V6H3V5h2V3h1v2h2V6
	z"
        />
    </svg>
)

export const NumberIcon: React.FunctionComponent = () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
        xmlSpace="preserve"
    >
        <g>
            <path d="M3.08,9.99V5.85L2.09,6.21L1.83,5.34l1.7-0.68h0.66v5.33H3.08z" />
            <path
                d="M6.04,4.96c0.19-0.12,0.4-0.22,0.64-0.29s0.49-0.11,0.78-0.11c0.53,0,0.95,0.14,1.25,0.42s0.46,0.68,0.46,1.18
          c0,0.21-0.03,0.41-0.08,0.6C9.03,6.96,8.96,7.14,8.86,7.31c-0.1,0.17-0.21,0.33-0.34,0.49S8.25,8.1,8.09,8.25
          C7.93,8.41,7.77,8.56,7.62,8.7s-0.3,0.27-0.44,0.4h2.03v0.89H5.9L5.75,9.35c0.14-0.15,0.28-0.29,0.4-0.41
          C6.26,8.82,6.38,8.7,6.48,8.59c0.11-0.11,0.21-0.22,0.31-0.32s0.2-0.22,0.31-0.34c0.12-0.13,0.23-0.27,0.35-0.4
          C7.57,7.4,7.67,7.26,7.76,7.12C7.85,6.98,7.92,6.84,7.97,6.7C8.03,6.55,8.06,6.4,8.06,6.25c0-0.25-0.07-0.45-0.22-0.59
          C7.7,5.52,7.5,5.45,7.24,5.45c-0.2,0-0.37,0.03-0.53,0.08s-0.3,0.12-0.42,0.2L6.04,4.96z"
            />
            <path
                d="M13.99,8.54c0,0.24-0.05,0.46-0.15,0.64s-0.23,0.35-0.4,0.48c-0.17,0.13-0.37,0.24-0.6,0.31
          c-0.23,0.07-0.47,0.11-0.74,0.11c-0.25,0-0.49-0.03-0.74-0.08c-0.25-0.05-0.47-0.12-0.66-0.21l0.18-0.83
          c0.17,0.07,0.34,0.13,0.52,0.18c0.18,0.05,0.37,0.07,0.57,0.07c0.3,0,0.53-0.07,0.68-0.2c0.15-0.13,0.22-0.3,0.22-0.5
          c0-0.27-0.11-0.47-0.34-0.59c-0.22-0.12-0.51-0.18-0.86-0.18h-0.45V6.85h0.3c0.4,0,0.7-0.07,0.92-0.22
          c0.22-0.14,0.32-0.34,0.32-0.59c0-0.19-0.07-0.34-0.2-0.44c-0.13-0.1-0.32-0.16-0.56-0.16c-0.34,0-0.66,0.07-0.96,0.22l-0.19-0.79
          c0.17-0.1,0.38-0.17,0.62-0.23c0.24-0.06,0.5-0.08,0.76-0.08c0.23,0,0.44,0.03,0.64,0.09s0.37,0.14,0.52,0.26
          c0.15,0.11,0.26,0.25,0.34,0.41c0.08,0.16,0.12,0.34,0.12,0.54c0,0.3-0.08,0.57-0.25,0.8c-0.17,0.23-0.42,0.42-0.75,0.56
          c0.15,0.04,0.29,0.1,0.43,0.18s0.25,0.17,0.36,0.28c0.1,0.11,0.18,0.24,0.24,0.38C13.96,8.21,13.99,8.37,13.99,8.54z"
            />
        </g>
    </svg>
)
export const StringIcon: React.FunctionComponent = () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
        xmlSpace="preserve"
    >
        <g>
            <path
                d="M6.24,11.41H5.08l-0.38-1.12H2.51l-0.38,1.12H0.98L3,6.08h1.22L6.24,11.41z M3.61,6.98L2.81,9.4h1.6L3.61,6.98
          z"
            />
            <path
                d="M10.77,9.91c0,0.24-0.05,0.45-0.16,0.63c-0.11,0.18-0.26,0.34-0.45,0.47c-0.19,0.13-0.42,0.23-0.7,0.3
          s-0.57,0.1-0.9,0.1H6.95V6.08h1.82c0.27,0,0.52,0.03,0.74,0.09c0.22,0.06,0.41,0.15,0.56,0.26c0.15,0.11,0.27,0.24,0.36,0.4
          c0.08,0.15,0.13,0.33,0.13,0.51c0,0.34-0.1,0.61-0.29,0.82s-0.46,0.37-0.8,0.47c0.38,0.06,0.7,0.2,0.93,0.41
          C10.65,9.25,10.77,9.55,10.77,9.91z M8.53,8.26c0.28,0,0.5-0.06,0.68-0.18c0.17-0.12,0.26-0.3,0.26-0.52
          c0-0.21-0.07-0.37-0.22-0.47c-0.15-0.1-0.35-0.15-0.61-0.15H8.05v1.33H8.53z M9.67,9.83c0-0.24-0.1-0.42-0.3-0.54
          C9.16,9.17,8.9,9.11,8.58,9.11H8.05v1.46h0.59c0.35,0,0.61-0.07,0.78-0.2C9.58,10.23,9.67,10.05,9.67,9.83z"
            />
            <path
                d="M14.18,5.99c0.13,0,0.27,0.01,0.41,0.02s0.27,0.03,0.4,0.06s0.26,0.05,0.38,0.09
          c0.12,0.03,0.23,0.08,0.32,0.12l-0.16,0.82c-0.17-0.06-0.36-0.12-0.57-0.16s-0.41-0.06-0.62-0.06c-0.61,0-1.07,0.16-1.4,0.47
          c-0.32,0.32-0.48,0.78-0.48,1.4c0,0.62,0.16,1.08,0.48,1.4c0.32,0.32,0.79,0.47,1.4,0.47c0.2,0,0.41-0.02,0.62-0.06
          s0.4-0.09,0.57-0.16l0.16,0.82c-0.1,0.05-0.2,0.09-0.32,0.12c-0.12,0.04-0.25,0.06-0.38,0.09s-0.27,0.04-0.4,0.05
          c-0.14,0.01-0.27,0.02-0.41,0.02c-0.46,0-0.86-0.07-1.22-0.21c-0.35-0.14-0.65-0.33-0.89-0.58c-0.24-0.25-0.42-0.54-0.54-0.87
          c-0.12-0.34-0.18-0.7-0.18-1.1s0.06-0.77,0.18-1.1c0.12-0.34,0.3-0.63,0.54-0.87c0.24-0.25,0.54-0.44,0.89-0.58
          C13.32,6.06,13.73,5.99,14.18,5.99z"
            />
        </g>
    </svg>
)

export const BooleanIcon: React.FunctionComponent = () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
        xmlSpace="preserve"
    >
        <g>
            <path d="M6.4,5.8v1H4.7v5H3.5v-5H1.8v-1H6.4z" />
            <path d="M8.6,5.4l1.1,0.4l-2.3,6.9l-1.1-0.4L8.6,5.4z" />
            <path d="M10.7,11.8v-6h3.6v1h-2.4v1.6h2.2v1h-2.2v2.4H10.7z" />
        </g>
    </svg>
)

export const DateIcon = () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
        xmlSpace="preserve"
    >
        <g>
            <path d="M6.4,5.8v1H4.7v5H3.5v-5H1.8v-1H6.4z" />
            <path d="M8.6,5.4l1.1,0.4l-2.3,6.9l-1.1-0.4L8.6,5.4z" />
            <path d="M10.7,11.8v-6h3.6v1h-2.4v1.6h2.2v1h-2.2v2.4H10.7z" />
        </g>
    </svg>
)

export const DeleteInputKeyIcon = () => (
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 11 11"
        xmlSpace="preserve"
    >
        <path
            d="M5.5,0C2.5,0,0,2.5,0,5.5c0,3,2.5,5.5,5.5,5.5S11,8.5,11,5.5C11,2.5,8.5,0,5.5,0z M8,6H6v2H5V6H3V5h2V3h1v2h2V6
                  z"
        />
    </svg>
)

export const GreenTickIcon = () => (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 32 32">
        <style
            type="text/css"
            dangerouslySetInnerHTML={{
                __html:
                    '\n.st0 {\n                                                                                        display: none;\n                                                                                    }\n\n                                                                                    .st1 {\n                                                                                        display: inline;\n                                                                                    }\n\n                                                                                    .st2 {\n                                                                                        fill: #2EB678;\n                                                                                    }\n\n                                                                                    .st3 {\n                                                                                        fill: #DBD9D9;\n                                                                                    }\n                                                                                '
            }}
        />
        <g id="Layer_1" className="st0">
            <g className="st1">
                <g>
                    <path
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14
				c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
                <g>
                    <path
                        d="M14.1,22c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
				c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-9.9,10C14.6,21.9,14.3,22,14.1,22z"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_2">
            <path
                className="st2"
                d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16c8.8,0,16-7.2,16-16S24.8,0,16,0z M24.7,11.7l-9.9,10
		c-0.2,0.2-0.5,0.3-0.7,0.3c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4s1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
		c0.4-0.4,1-0.4,1.4,0C25.1,10.7,25.1,11.3,24.7,11.7z"
            />
        </g>
        <g id="Layer_3" className="st0">
            <g className="st1">
                <g>
                    <path
                        className="st3"
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16
				s6.3,14,14,14c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
            </g>
        </g>
    </svg>
)
export const GreenTickIconMarketplace = () => (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 32 32">
        <style
            type="text/css"
            dangerouslySetInnerHTML={{
                __html:
                    '\n.st0 {\ndisplay: none;\n}\n\n.st1 {\ndisplay: inline;\n}\n\n.st2 {\nfill: #49CC81;\n}\n\n.st3 {\nfill: #49CC81;\n}\n'
            }}
        />
        <g id="Layer_1" className="st0">
            <g className="st1">
                <g>
                    <path
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14
				c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
                <g>
                    <path
                        d="M14.1,22c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
				c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-9.9,10C14.6,21.9,14.3,22,14.1,22z"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_2">
            <path
                className="st2"
                d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16c8.8,0,16-7.2,16-16S24.8,0,16,0z M24.7,11.7l-9.9,10
		c-0.2,0.2-0.5,0.3-0.7,0.3c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4s1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
		c0.4-0.4,1-0.4,1.4,0C25.1,10.7,25.1,11.3,24.7,11.7z"
            />
        </g>
        <g id="Layer_3" className="st0">
            <g className="st1">
                <g>
                    <path
                        className="st3"
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16
				s6.3,14,14,14c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const TickIconEmptyCircle = () => (
    <svg className="without_tick_svg" version="1.1" x="0px" y="0px" viewBox="0 0 32 32">
        <g id="Layer_1" className="st0">
            <g className="st1">
                <g>
                    <path
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14
				c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
                <g>
                    <path
                        d="M14.1,22c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
				c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-9.9,10C14.6,21.9,14.3,22,14.1,22z"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_2" className="st0">
            <g className="st1">
                <g>
                    <path
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14
				c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
                <g>
                    <path
                        d="M14.1,22c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
				c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-9.9,10C14.6,21.9,14.3,22,14.1,22z"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_3">
            <g>
                <g>
                    <path
                        className="st2"
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16
				s6.3,14,14,14c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const ConnectionLineIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 10 40.7"
        xmlSpace="preserve"
    >
        <g>
            <g>
                <path d="M5,35.6c-0.3,0-0.5-0.2-0.5-0.5v-30c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v30C5.5,35.4,5.3,35.6,5,35.6z" />
            </g>
            <circle cx={5} cy="5.1" r="2.5" />
        </g>
    </svg>
)

export const LeftPanelStepSuccessIcon = () => (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 32 32" className="blue_tick_svg">
        <g id="Layer_1">
            <g>
                <g>
                    <path
                        className="blue_tick_svg_1"
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14
				c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
                <g>
                    <path
                        className="blue_tick_svg_2"
                        d="M14.1,22c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
				c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-9.9,10C14.6,21.9,14.3,22,14.1,22z"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_2">
            <path
                className="blue_tick_svg_3"
                d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16c8.8,0,16-7.2,16-16S24.8,0,16,0z M24.7,11.7l-9.9,10
		c-0.2,0.2-0.5,0.3-0.7,0.3c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4s1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
		c0.4-0.4,1-0.4,1.4,0C25.1,10.7,25.1,11.3,24.7,11.7z"
            />
        </g>
        <g id="Layer_3">
            <g>
                <g>
                    <path
                        className="blue_tick_svg_4"
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16
				s6.3,14,14,14c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const WarningAlertIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 483.5 483.5" xmlSpace="preserve">
        <path d="M480 425L269.1 29.9c-5.3-9.9-15.6-16.1-26.8-16.1-11.2 0-21.5 6.2-26.8 16.1L3.6 425c-5 9.5-4.8 20.9.7 30 5.5 9.1 15.4 14.8 26.1 14.8h422.7c10.7 0 20.6-5.6 26.1-14.8 5.5-9.2 5.8-20.5.8-30zm-237.8-16c-16.8 0-30.4-13.6-30.4-30.4s13.6-30.4 30.4-30.4c16.8 0 30.4 13.6 30.4 30.4S259 409 242.2 409zm30.5-121.1c0 16.8-13.6 30.4-30.4 30.4-16.8 0-30.4-13.6-30.4-30.4V166.3c0-16.8 13.6-30.4 30.4-30.4 16.8 0 30.4 13.6 30.4 30.4v121.6z" />
    </svg>
)

export const MarketPlaceSettingIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 30 30" xmlSpace="preserve">
        <g>
            <g>
                <g>
                    <path
                        d="M15.3,18.5c-0.5,0-0.9-0.4-1-0.9c-0.1-0.7,0.2-2.2,1.7-3.4c0.5-0.4,0.6-0.7,0.6-1.1c0-0.7-0.6-1.3-1.2-1.3
				c-0.7,0-1.2,0.5-1.2,1.2c0,0.6-0.4,1-1,1s-1-0.4-1-1c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.5,3.2,3.3c0,1.1-0.4,1.9-1.3,2.7
				c-1,0.8-0.9,1.6-0.9,1.7C16.3,18,15.9,18.5,15.3,18.5C15.3,18.5,15.3,18.5,15.3,18.5z"
                    />
                </g>
                <g>
                    <path
                        d="M15.3,20.8c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.9-0.6-0.8-1.2c0.1-0.5,0.6-0.9,1.2-0.8c0.5,0.1,0.9,0.6,0.8,1.1l0,0
				C16.2,20.5,15.8,20.8,15.3,20.8z"
                    />
                </g>
            </g>
        </g>
        <g>
            <g>
                <g>
                    <path
                        d="M16.9,27.2H14c-0.5,0-0.9-0.4-1-0.9l-0.3-2.3c-0.5-0.2-1-0.4-1.5-0.6l-1.8,1.4c-0.4,0.3-1,0.3-1.3-0.1l-2-2
				c-0.4-0.3-0.4-0.9-0.1-1.3l1.4-1.9c-0.3-0.5-0.5-1-0.7-1.6l-2.2-0.3c-0.5-0.1-0.9-0.5-0.9-1v-2.9c0-0.5,0.4-0.9,0.9-1l2.3-0.3
				c0.2-0.5,0.4-1.1,0.7-1.6L5.8,9.1c-0.3-0.4-0.3-1,0.1-1.3l2-2c0.4-0.4,0.9-0.4,1.3-0.1L11.1,7c0.5-0.3,1-0.5,1.6-0.7L13,4.1
				c0.1-0.5,0.5-0.9,1-0.9h2.9c0.5,0,0.9,0.4,1,0.9l0.3,2.3c0.5,0.2,1,0.4,1.5,0.6l1.9-1.4c0.4-0.3,1-0.3,1.3,0.1l2,2
				C25.3,8,25.3,8.6,25,9l-1.4,1.8c0.3,0.5,0.5,1,0.7,1.6l2.3,0.3c0.5,0.1,0.9,0.5,0.9,1v2.9c0,0.5-0.4,0.9-0.9,1l-2.3,0.3
				c-0.2,0.5-0.4,1.1-0.6,1.6l1.4,1.8c0.3,0.4,0.3,1-0.1,1.3l-2,2c-0.3,0.4-0.9,0.4-1.3,0.1l-1.9-1.4c-0.5,0.3-1,0.5-1.6,0.7
				l-0.3,2.3C17.8,26.8,17.4,27.2,16.9,27.2z M14.9,25.2H16l0.3-2.1c0.1-0.4,0.4-0.8,0.8-0.8c0.8-0.2,1.5-0.5,2.2-0.9
				c0.3-0.2,0.8-0.2,1.1,0l1.7,1.2l0.8-0.8l-1.3-1.7c-0.3-0.3-0.3-0.8-0.1-1.1c0.4-0.7,0.7-1.4,0.9-2.2c0.1-0.4,0.4-0.7,0.8-0.8
				l2.1-0.3v-1.2l-2.1-0.3c-0.4-0.1-0.8-0.4-0.8-0.8c-0.2-0.8-0.5-1.6-0.9-2.3c-0.2-0.4-0.2-0.8,0-1.1l1.3-1.7l-0.8-0.8L20.4,9
				c-0.3,0.3-0.8,0.3-1.1,0.1c-0.7-0.4-1.4-0.7-2.2-0.9c-0.4-0.1-0.7-0.4-0.8-0.9L16,5.2h-1.2l-0.3,2.1c-0.1,0.4-0.4,0.8-0.8,0.8
				c-0.8,0.2-1.6,0.5-2.3,0.9c-0.4,0.2-0.8,0.2-1.1,0L8.7,7.7L8,8.5l1.3,1.6c0.3,0.3,0.3,0.8,0.1,1.2c-0.4,0.7-0.8,1.5-0.9,2.3
				c-0.1,0.4-0.4,0.7-0.8,0.8l-2,0.3v1.2l2,0.3c0.4,0.1,0.8,0.4,0.9,0.8c0.2,0.8,0.5,1.6,0.9,2.3c0.2,0.3,0.2,0.8,0,1.1L8,21.9
				l0.8,0.8l1.7-1.3c0.3-0.2,0.8-0.3,1.1-0.1c0.7,0.4,1.4,0.7,2.2,0.9c0.4,0.1,0.7,0.4,0.8,0.8L14.9,25.2z"
                    />
                </g>
            </g>
        </g>
    </svg>
)
export const NoTriggerVariable =
    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjMuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMiAzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzIgMzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTBGNkZGO30KCS5zdDF7ZmlsbDojMzU1RDhCO30KPC9zdHlsZT4KPGcgaWQ9Ikdyb3VwXzU4MjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NDYuNDIxIC0yMzQuNDIxKSI+Cgk8Y2lyY2xlIGlkPSJFbGxpcHNlXzI3IiBjbGFzcz0ic3QwIiBjeD0iNDYyLjQiIGN5PSIyNTAuNCIgcj0iMTYiLz4KCTxnIGlkPSJHcm91cF85MTY5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NTQuOTY3IDI0NC41NTIpIj4KCQk8ZyBpZD0iR3JvdXBfMzQ5MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCkiPgoJCQk8cGF0aCBpZD0iUGF0aF8yNDA4IiBjbGFzcz0ic3QxIiBkPSJNNC44LDEyLjdjLTAuMiwwLTAuNC0wLjItMC40LTAuNFYxMEMxLjYsOS43LTAuMyw3LjEsMC4xLDQuNEMwLjQsMS45LDIuNSwwLDUsMGg0LjgKCQkJCWMyLjgsMCw1LDIuMiw1LjEsNXMtMi4yLDUtNSw1LjFjMCwwLDAsMCwwLDBIOGwtMi45LDIuNUM1LDEyLjcsNC45LDEyLjcsNC44LDEyLjd6IE01LjMsOS43djEuNmwyLjMtMmMwLjEtMC4xLDAuMi0wLjEsMC4zLTAuMQoJCQkJaDJDMTIuMiw5LjIsMTQsNy4zLDE0LDVjMC0yLjMtMS45LTQuMi00LjItNC4ySDVDMi43LDAuOSwwLjksMi43LDAuOSw1YzAsMi4yLDEuNyw0LDMuOSw0LjJjMC4yLDAsMC41LDAuMiwwLjUsMC40YzAsMCwwLDAsMCwwCgkJCQlDNS4zLDkuNyw1LjMsOS43LDUuMyw5LjdMNS4zLDkuN3oiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=='
export const IfNodeIcon =
    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjMuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMiAzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzIgMzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTBGNkZGO30KCS5zdDF7ZmlsbDojNDY2MzgyO30KPC9zdHlsZT4KPGcgaWQ9Ikdyb3VwXzExNTM5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4wOCAtMC4wOCkiPgoJPGNpcmNsZSBpZD0iRWxsaXBzZV83MDAiIGNsYXNzPSJzdDAiIGN4PSIxNi4xIiBjeT0iMTYuMSIgcj0iMTYiLz4KCTxnIGlkPSJHcm91cF8xMTUzNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAuMDggOC4wOCkiPgoJCTxwYXRoIGlkPSJQYXRoXzc5MDIiIGNsYXNzPSJzdDEiIGQ9Ik0yLjYsMi4zQzIuNiwzLDIsMy40LDEuMiwzLjRDMC42LDMuNCwwLjEsMywwLDIuNGMwLDAsMC0wLjEsMC0wLjFDMCwxLjYsMC42LDEsMS4zLDEKCQkJYzAsMCwwLDAsMC4xLDBDMi4xLDEsMi42LDEuNiwyLjYsMi4zeiBNMC4yLDE1LjhWNS4yaDIuMnYxMC42SDAuMnoiLz4KCQk8cGF0aCBpZD0iUGF0aF83OTAzIiBjbGFzcz0ic3QxIiBkPSJNNS4xLDE1LjhWNi42SDMuNVY1LjFoMS42VjQuNkM0LjksMy4yLDUuNSwxLjksNi41LDAuOWMwLjgtMC43LDEuOC0xLDIuOC0wLjkKCQkJYzAuNiwwLDEuMiwwLjEsMS44LDAuNGwtMC4yLDEuNWMtMC40LTAuMi0wLjktMC4yLTEuNC0wLjJjLTEuOCwwLTIuMiwxLjUtMi4yLDMuMXYwLjZIMTB2MS41SDcuMlYxNkg1LjFWMTUuOHoiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K'

export const NoTriggerIcon =
   'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI3LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMC42IDkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEwLjYgOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiMzNTVEOEI7fQo8L3N0eWxlPgo8ZyBpZD0iR3JvdXBfMTM5MTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zODkgLTcyNCkiPgoJPGcgaWQ9Ikdyb3VwXzM0OTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM4OSA3MjQpIj4KCQk8cGF0aCBpZD0iUGF0aF8yNDA4IiBjbGFzcz0ic3QwIiBkPSJNMy40LDlDMy4zLDksMy4xLDguOSwzLjEsOC43bDAsMFY3LjFjLTItMC4zLTMuMy0yLjEtMy4xLTRDMC4zLDEuMywxLjgsMCwzLjYsMEg3CgkJCWMyLDAsMy42LDEuNywzLjUsMy42YzAsMS45LTEuNiwzLjUtMy41LDMuNUg1LjdMMy42LDlDMy42LDksMy41LDksMy40LDl6IE0zLjcsNi45VjhsMS42LTEuNGMwLjEsMCwwLjEtMC4xLDAuMi0wLjFINwoJCQljMS42LDAsMy0xLjMsMy0zYzAtMS42LTEuMy0zLTMtM0gzLjZjLTEuNiwwLTMsMS4zLTMsMi45YzAsMS42LDEuMiwyLjksMi44LDNDMy42LDYuNSwzLjcsNi43LDMuNyw2LjlDMy43LDYuOCwzLjcsNi44LDMuNyw2LjkKCQkJQzMuNyw2LjksMy43LDYuOSwzLjcsNi45TDMuNyw2Ljl6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=='
export const ErrorHandlingSuccessIcon =
    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNiAzNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzYgMzY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMjBDRTg4O30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTgsMi4zYy04LjgsMC0xNiw3LjItMTYsMTZjMCw4LjgsNy4yLDE2LDE2LDE2YzguOCwwLDE2LTcuMiwxNi0xNkMzNCw5LjUsMjYuOCwyLjMsMTgsMi4zeiBNMjYuNywxNGwtOS45LDEwCgkJYy0wLjIsMC4yLTAuNSwwLjMtMC43LDAuM2MtMC4yLDAtMC41LTAuMS0wLjYtMC4ybC02LjEtNS4yYy0wLjQtMC40LTAuNS0xLTAuMS0xLjRjMC40LTAuNCwxLTAuNSwxLjQtMC4xbDUuNCw0LjZsOS4zLTkuMwoJCWMwLjQtMC40LDEtMC40LDEuNCwwQzI3LjEsMTMsMjcuMSwxMy42LDI2LjcsMTR6Ii8+CjwvZz4KPC9zdmc+Cg=='

export const ErrorHandlingFailIcon =
    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNiAzNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzYgMzY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRUE0NjM5O30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTE4LDIuM2MtOC44LDAtMTYsNy4yLTE2LDE2YzAsOC44LDcuMiwxNiwxNiwxNmM4LjgsMCwxNi03LjIsMTYtMTZDMzQsOS41LDI2LjgsMi4zLDE4LDIuM3ogTTIzLjcsMjIuNgoJYzAuNCwwLjQsMC40LDEsMCwxLjRjLTAuMiwwLjItMC41LDAuMy0wLjcsMC4zcy0wLjUtMC4xLTAuNy0wLjNMMTgsMTkuN0wxMy43LDI0Yy0wLjIsMC4yLTAuNSwwLjMtMC43LDAuM3MtMC41LTAuMS0wLjctMC4zCgljLTAuNC0wLjQtMC40LTEsMC0xLjRsNC4zLTQuM0wxMi4zLDE0Yy0wLjQtMC40LTAuNC0xLDAtMS40YzAuNC0wLjQsMS0wLjQsMS40LDBsNC4zLDQuM2w0LjMtNC4zYzAuNC0wLjQsMS0wLjQsMS40LDAKCWMwLjQsMC40LDAuNCwxLDAsMS40bC00LjMsNC4zTDIzLjcsMjIuNnoiLz4KPC9zdmc+Cg=='

export const ErrorHandlingOthersIcon =
    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNiAzNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzYgMzY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkQ3QjA1O30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTgsMTMuN2MtMC42LDAtMSwwLjUtMSwxdjQuMmMwLDAuNiwwLjUsMSwxLDFjMC42LDAsMS0wLjUsMS0xdi00LjJDMTkuMSwxNC4xLDE4LjYsMTMuNywxOCwxMy43eiIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE4LDIuM2MtOC44LDAtMTYsNy4yLTE2LDE2YzAsOC44LDcuMiwxNiwxNiwxNmM4LjgsMCwxNi03LjIsMTYtMTZDMzQsOS41LDI2LjgsMi4zLDE4LDIuM3ogTTI2LjEsMjQuNgoJCWMtMC4yLDAuMy0wLjUsMC41LTAuOSwwLjVIMTAuOGMtMC40LDAtMC43LTAuMi0wLjktMC41Yy0wLjItMC4zLTAuMi0wLjcsMC0xTDE3LjEsMTBjMC4yLTAuMywwLjUtMC42LDAuOS0wLjYKCQljMC40LDAsMC43LDAuMiwwLjksMC42bDcuMiwxMy41QzI2LjMsMjMuOSwyNi4zLDI0LjMsMjYuMSwyNC42eiIvPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE4LDIwLjljLTAuNiwwLTEsMC41LTEsMWMwLDAuNiwwLjUsMSwxLDFzMS0wLjUsMS0xQzE5LjEsMjEuNCwxOC42LDIwLjksMTgsMjAuOXoiLz4KPC9nPgo8L3N2Zz4K'

export const FunctionNodeIcon =
    'data:image/svg+xml;base64,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'
export const ForEachNodeIcon =
    'data:image/svg+xml;base64,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'
export const ApprovalIcon =
    'data:image/svg+xml;base64,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'

export const NotificationNodeIcon ='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI3LjQuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMiAzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzIgMzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTBGNkZGO30KCS5zdDF7Y2xpcC1wYXRoOnVybCgjU1ZHSURfMDAwMDAxNzUzMDM3NjUxNjcwMDQxNzcxNjAwMDAwMTU2NTU2MTAyNzA5MDg3MDQ0MjhfKTt9Cgkuc3Qye2ZpbGw6IzMwNUI4Qjt9Cjwvc3R5bGU+CjxnIGlkPSJHcm91cF8xNDU0MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc4OCAtMzIyLjI0MSkiPgoJPGcgaWQ9Ikdyb3VwXzEzOTM5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNDEuMTQ2IDg3LjM4NykiPgoJCTxjaXJjbGUgaWQ9IkVsbGlwc2VfMjciIGNsYXNzPSJzdDAiIGN4PSI0NjIuOSIgY3k9IjI1MC45IiByPSIxNiIvPgoJPC9nPgoJPGcgaWQ9Ikdyb3VwXzEzOTQwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OTYgMzMwKSI+CgkJPGc+CgkJCTxkZWZzPgoJCQkJPHJlY3QgaWQ9IlNWR0lEXzFfIiB5PSIwIiB3aWR0aD0iMTUuMSIgaGVpZ2h0PSIxNi45Ii8+CgkJCTwvZGVmcz4KCQkJPGNsaXBQYXRoIGlkPSJTVkdJRF8wMDAwMDA0MzQzOTQxMzg5MzE2MjI1NjA4MDAwMDAxMTQyMjEwMjc0MzcxMTI2MDI5Nl8iPgoJCQkJPHVzZSB4bGluazpocmVmPSIjU1ZHSURfMV8iICBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTsiLz4KCQkJPC9jbGlwUGF0aD4KCQkJCgkJCQk8ZyBpZD0iR3JvdXBfMTI3MDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIHN0eWxlPSJjbGlwLXBhdGg6dXJsKCNTVkdJRF8wMDAwMDA0MzQzOTQxMzg5MzE2MjI1NjA4MDAwMDAxMTQyMjEwMjc0MzcxMTI2MDI5Nl8pOyI+CgkJCQk8cGF0aCBpZD0iUGF0aF8xMDMwNCIgY2xhc3M9InN0MiIgZD0iTTE0LjksMTMuOEMxMy4xLDEzLDEzLDkuNSwxMyw5LjRWNy4xYzAtMi4yLTEuMy00LjItMy4zLTVDOS43LDAuOSw4LjcsMCw3LjYsMAoJCQkJCVM1LjUsMC45LDUuNSwyLjFjLTIsMC44LTMuMywyLjgtMy4zLDV2Mi4zYzAsMC4xLTAuMSwzLjYtMS45LDQuNEMwLDEzLjktMC4xLDE0LjIsMCwxNC40YzAuMSwwLjIsMC4yLDAuMywwLjQsMC4zSDUKCQkJCQljMC4xLDAuNSwwLjMsMSwwLjcsMS40YzAuOSwxLDIuNSwxLjEsMy42LDAuMWMwLDAsMC4xLTAuMSwwLjEtMC4xYzAuNC0wLjQsMC42LTAuOSwwLjctMS40aDQuNmMwLjMsMCwwLjUtMC4yLDAuNS0wLjUKCQkJCQlDMTUuMSwxNC4xLDE1LDEzLjksMTQuOSwxMy44IE0xMi41LDEyLjFjMC4yLDAuNiwwLjUsMS4xLDAuOCwxLjZIMS44YzAuNC0wLjUsMC43LTEsMC44LTEuNkgxMi41eiBNNy42LDFjMC41LDAsMSwwLjMsMS4xLDAuOAoJCQkJCWMtMC43LTAuMi0xLjUtMC4yLTIuMiwwQzYuNiwxLjMsNy4xLDEsNy42LDEgTTMuMSw5LjRWNy4xYzAtMi41LDIuMS00LjQsNC41LTQuNGMyLjQsMCw0LjQsMiw0LjQsNC40djIuMwoJCQkJCWMwLDAuNiwwLjEsMS4yLDAuMiwxLjhIMi45QzMsMTAuNiwzLjEsMTAsMy4xLDkuNCBNNy42LDE1LjljLTAuNywwLTEuNC0wLjUtMS42LTEuMmgzLjFDOC45LDE1LjQsOC4zLDE1LjksNy42LDE1LjkiLz4KCQkJCTxwYXRoIGlkPSJQYXRoXzEwMzA1IiBjbGFzcz0ic3QyIiBkPSJNNy42LDMuM0M1LjUsMy4zLDMuOSw1LDMuOSw3YzAsMC4zLDAuMiwwLjUsMC41LDAuNWMwLjMsMCwwLjUtMC4yLDAuNS0wLjUKCQkJCQljMC0xLjUsMS4yLTIuOCwyLjgtMi44QzcuOCw0LjIsOCw0LDgsMy44QzgsMy41LDcuOCwzLjMsNy42LDMuMyIvPgoJCQk8L2c+CgkJPC9nPgoJPC9nPgo8L2c+Cjwvc3ZnPgo='

export const ForEachIcon = () => (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" xmlSpace="preserve">
        {/* <style>{'.st0{fill:#466382}'}</style> */}
        <g id="Group_12705" transform="translate(-314 -407)">
            <g id="Group_11545" transform="translate(-540.47 -1539.186)">
                <g id="Group_11552" transform="translate(863.413 1960.297)">
                    <g id="Group_11548" transform="translate(0 3.778)">
                        <g id="Group_11547">
                            <g id="Group_11546">
                                <g id="Group_11545-2">
                                    <path
                                        id="Path_7909"
                                        className="st0"
                                        d="M3.1 6.3c-.1 0-.3-.1-.4-.2L.2 3.6C0 3.4 0 3 .2 2.7L2.7.2c.3-.2.7-.2.9 0 .2.2.2.6 0 .8L1.5 3.2l2.1 2.1c.2.2.2.6 0 .9-.1 0-.3.1-.5.1z"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="Group_11551">
                        <g id="Group_11549" transform="translate(0 6.297)">
                            <path
                                id="Path_7910"
                                className="st0"
                                d="M11.3 1.3H.6C.3 1.3 0 1 0 .6S.3 0 .6 0h10.7c.4 0 .7.3.7.6s-.3.7-.7.7z"
                            />
                        </g>
                        <g id="Group_11550" transform="translate(10.705)">
                            <path
                                id="Path_7911"
                                className="st0"
                                d="M.6 7.6c-.3 0-.6-.3-.6-.7s.3-.6.6-.6c1.4 0 2.5-1.1 2.5-2.5V.6c0-.3.3-.6.7-.6s.6.3.6.6v3.1c0 2.2-1.7 3.9-3.8 3.9z"
                            />
                        </g>
                    </g>
                </g>
                <g id="Group_11560" transform="translate(862.414 1954)">
                    <g id="Group_11556" transform="translate(11.334)">
                        <g id="Group_11555">
                            <g id="Group_11554">
                                <g id="Group_11553">
                                    <path
                                        id="Path_7912"
                                        className="st0"
                                        d="M.6 6.3C.3 6.3 0 6 0 5.7c0-.2.1-.3.2-.4l2.1-2.1L.2 1.1C0 .8 0 .4.2.2c.3-.2.6-.2.9 0l2.5 2.5c.2.2.2.6 0 .9L1.1 6.1c-.1.1-.3.2-.5.2z"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="Group_11559" transform="translate(0 2.519)">
                        <g id="Group_11557" transform="translate(3.148)">
                            <path
                                id="Path_7913"
                                className="st0"
                                d="M11.3 1.3H.6C.3 1.3 0 1 0 .6S.3 0 .6 0h10.7c.4 0 .7.3.7.6s-.3.7-.7.7z"
                            />
                        </g>
                        <g id="Group_11558">
                            <path
                                id="Path_7914"
                                className="st0"
                                d="M.6 7.6c-.3 0-.6-.3-.6-.7V3.8C0 1.7 1.7 0 3.8 0c.3 0 .6.3.6.6s-.3.7-.6.7c-1.4 0-2.5 1.1-2.5 2.5v3.1c0 .4-.3.7-.7.7z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const ExpendIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 16 16" xmlSpace="preserve">
        <path d="M14.5 15H8.4c-.2 0-.4-.2-.4-.5V8.4c0-.2.2-.4.4-.4h6.1c.3 0 .5.2.5.4v6.1c0 .3-.2.5-.5.5zm-5.6-.9h5.2V8.9H8.9v5.2z" />
        <path d="M8.4 8.9c-.1 0-.2 0-.3-.1L3.8 4.4c-.2-.2-.2-.4 0-.6.2-.2.4-.2.6 0l4.4 4.4c.2.2.2.4 0 .6-.1 0-.3.1-.4.1z" />
        <path d="M4.1 7.1c-.2 0-.4-.2-.4-.4V4.1c0-.2.2-.4.4-.4h2.6c.2 0 .4.2.4.4s-.2.4-.4.4H4.5v2.2c0 .2-.2.4-.4.4zM3.2 15H1.5c-.3 0-.5-.2-.5-.5v-1.7c0-.2.2-.4.4-.4s.4.2.4.4v1.3h1.3c.2 0 .4.2.4.4s-.1.5-.3.5zM14.5 3.6c-.2 0-.4-.2-.4-.4V1.9h-1.3c-.2 0-.4-.2-.4-.4s.2-.5.4-.5h1.7c.3 0 .5.2.5.5v1.7c0 .2-.2.4-.5.4zM1.5 3.6c-.3 0-.5-.2-.5-.4V1.5c0-.3.2-.5.5-.5h1.7c.2 0 .4.2.4.4s-.2.5-.4.5H1.9v1.3c0 .2-.2.4-.4.4zM1.5 11.5c-.2 0-.4-.2-.4-.4V8.9c0-.2.2-.4.4-.4s.4.2.4.4v2.2c0 .2-.2.4-.4.4zM6.7 15H4.9c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h1.7c.2 0 .4.2.4.4s-.1.4-.3.4zM1.5 7.6c-.3 0-.5-.2-.5-.5V4.9c0-.2.2-.4.4-.4s.4.2.4.4v2.2c.1.3-.1.5-.3.5zM7.1 1.9H4.9c-.2 0-.4-.2-.4-.4s.2-.5.4-.5h2.2c.2 0 .4.2.4.4s-.1.5-.4.5zM11.1 1.9H8.9c-.2 0-.4-.2-.4-.4s.1-.5.4-.5h2.2c.2 0 .4.2.4.4s-.2.5-.4.5zM14.5 7.1c-.2 0-.4-.2-.4-.4V4.9c0-.2.2-.4.4-.4s.5.2.5.4v1.7c0 .3-.2.5-.5.5z" />
    </svg>
)

export const PasswordEyeOpen = () => {
    return (
        <svg
            // onClick={toggle}
            className="pwd_open_eye"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 511.626 511.626"
            xmlSpace="preserve"
        >
            <title>Show</title>
            <g>
                <path
                    d="M505.918,236.117c-26.651-43.587-62.485-78.609-107.497-105.065c-45.015-26.457-92.549-39.687-142.608-39.687
              c-50.059,0-97.595,13.225-142.61,39.687C68.187,157.508,32.355,192.53,5.708,236.117C1.903,242.778,0,249.345,0,255.818
              c0,6.473,1.903,13.04,5.708,19.699c26.647,43.589,62.479,78.614,107.495,105.064c45.015,26.46,92.551,39.68,142.61,39.68
              c50.06,0,97.594-13.176,142.608-39.536c45.012-26.361,80.852-61.432,107.497-105.208c3.806-6.659,5.708-13.223,5.708-19.699
              C511.626,249.345,509.724,242.778,505.918,236.117z M194.568,158.03c17.034-17.034,37.447-25.554,61.242-25.554
              c3.805,0,7.043,1.336,9.709,3.999c2.662,2.664,4,5.901,4,9.707c0,3.809-1.338,7.044-3.994,9.704
              c-2.662,2.667-5.902,3.999-9.708,3.999c-16.368,0-30.362,5.808-41.971,17.416c-11.613,11.615-17.416,25.603-17.416,41.971
              c0,3.811-1.336,7.044-3.999,9.71c-2.667,2.668-5.901,3.999-9.707,3.999c-3.809,0-7.044-1.334-9.71-3.999
              c-2.667-2.666-3.999-5.903-3.999-9.71C169.015,195.482,177.535,175.065,194.568,158.03z M379.867,349.04
              c-38.164,23.12-79.514,34.687-124.054,34.687c-44.539,0-85.889-11.56-124.051-34.687s-69.901-54.2-95.215-93.222
              c28.931-44.921,65.19-78.518,108.777-100.783c-11.61,19.792-17.417,41.207-17.417,64.236c0,35.216,12.517,65.329,37.544,90.362
              s55.151,37.544,90.362,37.544c35.214,0,65.329-12.518,90.362-37.544s37.545-55.146,37.545-90.362
              c0-23.029-5.808-44.447-17.419-64.236c43.585,22.265,79.846,55.865,108.776,100.783C449.767,294.84,418.031,325.913,379.867,349.04
              z"
                />
            </g>
        </svg>
    )
}

export const PasswordEyeClose = () => {
    return (
        <svg
            // onClick={toggle}
            className="pwd_open_eye"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 511.626 511.626"
            xmlSpace="preserve"
        >
            <title>Hide</title>
            <g>
                <g>
                    <path
                        d="M361.161,291.652c15.037-21.796,22.56-45.922,22.56-72.375c0-7.422-0.76-15.417-2.286-23.984l-79.938,143.321
              C326.235,329.101,346.125,313.438,361.161,291.652z"
                    />
                    <path
                        d="M372.872,94.221c0.191-0.378,0.28-1.235,0.28-2.568c0-3.237-1.522-5.802-4.571-7.715c-0.568-0.38-2.423-1.475-5.568-3.287
              c-3.138-1.805-6.14-3.567-8.989-5.282c-2.854-1.713-5.989-3.472-9.422-5.28c-3.426-1.809-6.375-3.284-8.846-4.427
              c-2.479-1.141-4.189-1.713-5.141-1.713c-3.426,0-6.092,1.525-7.994,4.569l-15.413,27.696c-17.316-3.234-34.451-4.854-51.391-4.854
              c-51.201,0-98.404,12.946-141.613,38.831C70.998,156.08,34.836,191.385,5.711,236.114C1.903,242.019,0,248.586,0,255.819
              c0,7.231,1.903,13.801,5.711,19.698c16.748,26.073,36.592,49.396,59.528,69.949c22.936,20.561,48.011,37.018,75.229,49.396
              c-8.375,14.273-12.562,22.556-12.562,24.842c0,3.425,1.524,6.088,4.57,7.99c23.219,13.329,35.97,19.985,38.256,19.985
              c3.422,0,6.089-1.529,7.992-4.575l13.99-25.406c20.177-35.967,50.248-89.931,90.222-161.878
              C322.908,183.871,352.886,130.005,372.872,94.221z M158.456,362.885C108.97,340.616,68.33,304.93,36.547,255.822
              c28.931-44.921,65.19-78.518,108.777-100.783c-11.61,19.792-17.417,41.206-17.417,64.237c0,20.365,4.661,39.68,13.99,57.955
              c9.327,18.274,22.27,33.4,38.83,45.392L158.456,362.885z M265.525,155.887c-2.662,2.667-5.906,3.999-9.712,3.999
              c-16.368,0-30.361,5.808-41.971,17.416c-11.613,11.615-17.416,25.603-17.416,41.971c0,3.811-1.336,7.044-3.999,9.71
              c-2.668,2.667-5.902,3.999-9.707,3.999c-3.809,0-7.045-1.334-9.71-3.999c-2.667-2.666-3.999-5.903-3.999-9.71
              c0-23.79,8.52-44.206,25.553-61.242c17.034-17.034,37.447-25.553,61.241-25.553c3.806,0,7.043,1.336,9.713,3.999
              c2.662,2.664,3.996,5.901,3.996,9.707C269.515,149.992,268.181,153.228,265.525,155.887z"
                    />
                    <path
                        d="M505.916,236.114c-10.853-18.08-24.603-35.594-41.255-52.534c-16.646-16.939-34.022-31.496-52.105-43.68l-17.987,31.977
              c31.785,21.888,58.625,49.87,80.51,83.939c-23.024,35.782-51.723,65-86.07,87.648c-34.358,22.661-71.712,35.693-112.065,39.115
              l-21.129,37.688c42.257,0,82.18-9.038,119.769-27.121c37.59-18.076,70.668-43.488,99.216-76.225
              c13.322-15.421,23.695-29.219,31.121-41.401c3.806-6.476,5.708-13.046,5.708-19.702
              C511.626,249.157,509.724,242.59,505.916,236.114z"
                    />
                </g>
            </g>
        </svg>
    )
}
